import { useState } from "react";
import { CloseButton, Dialog, Portal } from "@chakra-ui/react"
import { IconButton } from "@chakra-ui/react"
import { Search } from "lucide-react";
import ImpactReportSearchForm from "./search-dialog";

export default function SearchImpactReports() {
    const [open, setOpen] = useState(false);

    return(
        <Dialog.Root size="lg" placement="top" motionPreset="slide-in-bottom" open={open} onOpenChange={(e) => setOpen(e.open)}>
            <Dialog.Trigger asChild css={{ position: "fixed", bottom: "36px", right: "28px", zIndex: 999 }}>
                <IconButton 
                    aria-label="Search database"
                    rounded={'full'}
                >
                    <Search />
                </IconButton>
            </Dialog.Trigger>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner css={{ overflowX: 'hidden' }}>
                    <Dialog.Content css={{ padding: 'var(--space-2xs)'}}>
                        <Dialog.Header>
                            <Dialog.Title fontSize={'2xl'}>Search Impact Reports</Dialog.Title>
                            <Dialog.CloseTrigger asChild>
                                <CloseButton size="sm" aria-label="Close search dialog" />
                            </Dialog.CloseTrigger>
                        </Dialog.Header>
                        <Dialog.Body>
                            <ImpactReportSearchForm onNavigate={() => setOpen(false)} />
                        </Dialog.Body>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>

    );
}